import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AnalystDashboard from "./pages/AnalystDashboard";
import Invoices from "./pages/Invoices";
import InvoiceForm from "./pages/InvoiceForm";
import InvoiceDetail from "./pages/InvoiceDetail";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Banks from "./pages/Banks";
import Payments from "./pages/Payments";
import Settings from "./pages/Settings";
import Reports from "./pages/Reports";
import Recurring from "./pages/Recurring";
import Audit from "./pages/Audit";
import BillingHealth from "./pages/BillingHealth";
import ClientIntelligence from "./pages/ClientIntelligence";
import Collections from "./pages/Collections";
import Expenses from "./pages/Expenses";
import InvoiceUpload from "./pages/InvoiceUpload";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleAwareDashboard from "./components/RoleAwareDashboard";
import CommandPalette from "./components/CommandPalette";

function AppShell() {
  const [paletteOpen, setPaletteOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setPaletteOpen(o => !o);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<ProtectedRoute><RoleAwareDashboard admin={<Dashboard />} analyst={<AnalystDashboard />} /></ProtectedRoute>} />
        <Route path="/billing-health" element={<ProtectedRoute><BillingHealth /></ProtectedRoute>} />
        <Route path="/client-intelligence" element={<ProtectedRoute><ClientIntelligence /></ProtectedRoute>} />
        <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
        <Route path="/invoices/upload" element={<ProtectedRoute adminOnly><InvoiceUpload /></ProtectedRoute>} />
        <Route path="/invoices/new" element={<ProtectedRoute adminOnly><InvoiceForm /></ProtectedRoute>} />
        <Route path="/invoices/:id" element={<ProtectedRoute><InvoiceDetail /></ProtectedRoute>} />
        <Route path="/invoices/:id/edit" element={<ProtectedRoute adminOnly><InvoiceForm /></ProtectedRoute>} />
        <Route path="/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
        <Route path="/clients/:id" element={<ProtectedRoute><ClientDetail /></ProtectedRoute>} />
        <Route path="/banks" element={<ProtectedRoute><Banks /></ProtectedRoute>} />
        <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
        <Route path="/collections" element={<ProtectedRoute><Collections /></ProtectedRoute>} />
        <Route path="/expenses" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/recurring" element={<ProtectedRoute adminOnly><Recurring /></ProtectedRoute>} />
        <Route path="/retainers" element={<ProtectedRoute adminOnly><Recurring /></ProtectedRoute>} />
        <Route path="/audit" element={<ProtectedRoute adminOnly><Audit /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute adminOnly><Settings /></ProtectedRoute>} />
      </Routes>
      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

export default App;
